import ConvoUS from "../src/assets/Logo/ConvoUS.svg";
import AddressBarAU from "../src/assets/Help/Android/Android-Chrome-AddressBarAU.png";
import AddressBarUS from "../src/assets/Help/Android/Android-Chrome-AddressBarUS.png";
import AddressBarUK from "../src/assets/Help/Android/Android-Chrome-AddressBarUK.png";
import PermissionSettingsAU from "../src/assets/Help/Android/Android-Chrome-MenuAU.png";
import PermissionSettingsUS from "../src/assets/Help/Android/Android-Chrome-MenuUS.png";
import PermissionSettingsUK from "../src/assets/Help/Android/Android-Chrome-MenuUK.png";
import PermissionOffAU from "../src/assets/Help/Android/Android-Chrome-SettingsCamMicOffAU.png";
import PermissionOffUS from "../src/assets/Help/Android/Android-Chrome-SettingsCamMicOffUS.png";
import PermissionOffUK from "../src/assets/Help/Android/Android-Chrome-SettingsCamMicOffUK.png";
import PermissionOnAU from "../src/assets/Help/Android/Android-Chrome-SettingsCamMicOnAU.png";
import PermissionOnUS from "../src/assets/Help/Android/Android-Chrome-SettingsCamMicOnUS.png";
import PermissionOnUK from "../src/assets/Help/Android/Android-Chrome-SettingsCamMicOnUK.png";
import AllowControlsAU from "../src/assets/Help/IOS/iOS-Chrome-PermissionDialogAU.png";
import AllowControlsUS from "../src/assets/Help/IOS/iOS-Chrome-PermissionDialogUS.png";
import AllowControlsUK from "../src/assets/Help/IOS/iOS-Chrome-PermissionDialogUK.png";
import AddressBarSafariAU from "../src/assets/Help/IOS/iOS-Safari-AddressBarAU.png";
import AddressBarSafariUS from "../src/assets/Help/IOS/iOS-Safari-AddressBarUS.png";
import AddressBarSafariUK from "../src/assets/Help/IOS/iOS-Safari-AddressBarUK.png";
import DenyAllowAU from "../src/assets/Help/IOS/iOS-Safari-CamMicSettingsDeniedAU.png";
import DenyAllowUS from "../src/assets/Help/IOS/iOS-Safari-CamMicSettingsDeniedUS.png";
import DenyAllowUK from "../src/assets/Help/IOS/iOS-Safari-CamMicSettingsDeniedUK.png";
import AllowCamSettingsAU from "../src/assets/Help/IOS/iOS-Safari-CamSettingAllowAU.png";
import AllowCamSettingsUS from "../src/assets/Help/IOS/iOS-Safari-CamSettingAllowUS.png";
import AllowMicSettingsAU from "../src/assets/Help/IOS/iOS-Safari-MicSettingAllowAU.png";
import AllowMicSettingsUS from "../src/assets/Help/IOS/iOS-Safari-MicSettingAllowUS.png";
import AllowCamSettingsUK from "../src/assets/Help/IOS/iOS-Safari-CamSettingAllowUK.png";
import AllowMicSettingsUK from "../src/assets/Help/IOS/iOS-Safari-MicSettingAllowUK.png";

type ConfigType = {
  [key: string]: {
    appName: string;
    companyName: string;
    region: string;
    appLogoImageSrc: string;
    addressBarImageSrc: string;
    permissionSettingImageSrc: string;
    permissionOffImageSrc: string;
    permissionOnImageSrc: string;
    allowControlsImageSrc: string;
    addressBarSafariImageSrc: string;
    denyAllowImageSrc: string;
    allowCamSettingsImageSrc: string;
    allowMicSettingsImageSrc: string;
    appLogoImageHeight: number;
    ratingScreenText: string;
    marketingUrl: string;
    hubspotFeedbackUrl: string;
    huHubspotFeedbackUrl: string;
    huMarketingUrl: string;
    legalURL: string;
  };
};

const Config: ConfigType = {
  US: {
    appName: "Convo Now",
    companyName: "Convo",
    region: "US",
    appLogoImageSrc: ConvoUS,
    addressBarImageSrc: AddressBarUS,
    permissionSettingImageSrc: PermissionSettingsUS,
    permissionOffImageSrc: PermissionOffUS,
    permissionOnImageSrc: PermissionOnUS,
    allowControlsImageSrc: AllowControlsUS,
    addressBarSafariImageSrc: AddressBarSafariUS,
    denyAllowImageSrc: DenyAllowUS,
    allowCamSettingsImageSrc: AllowCamSettingsUS,
    allowMicSettingsImageSrc: AllowMicSettingsUS,
    appLogoImageHeight: 25,
    ratingScreenText: "How was your experience using Convo today?",
    marketingUrl: `${process.env.REACT_APP_MARKETING_URL}`,
    hubspotFeedbackUrl: `${process.env.REACT_APP_HUBSPOT_FEEDBACK_URL}`,
    huMarketingUrl: `${process.env.REACT_APP_HU_MARKETING_URL}`,
    huHubspotFeedbackUrl: `${process.env.REACT_APP_HU_HUBSPOT_FEEDBACK_URL}`,
    legalURL: `${process.env.REACT_APP_LEGAL_URL}`,
  },
  AU: {
    appName: "Convo Now",
    companyName: "Convo",
    region: "AU",
    appLogoImageSrc: ConvoUS,
    addressBarImageSrc: AddressBarAU,
    permissionSettingImageSrc: PermissionSettingsAU,
    permissionOffImageSrc: PermissionOffAU,
    permissionOnImageSrc: PermissionOnAU,
    allowControlsImageSrc: AllowControlsAU,
    addressBarSafariImageSrc: AddressBarSafariAU,
    denyAllowImageSrc: DenyAllowAU,
    allowCamSettingsImageSrc: AllowCamSettingsAU,
    allowMicSettingsImageSrc: AllowMicSettingsAU,
    appLogoImageHeight: 25,
    ratingScreenText: "How was your experience using Convo today?",
    marketingUrl: `${process.env.REACT_APP_MARKETING_URL}`,
    hubspotFeedbackUrl: `${process.env.REACT_APP_HUBSPOT_FEEDBACK_URL}`,
    huMarketingUrl: `${process.env.REACT_APP_HU_MARKETING_URL}`,
    huHubspotFeedbackUrl: `${process.env.REACT_APP_HU_HUBSPOT_FEEDBACK_URL}`,
    legalURL: `${process.env.REACT_APP_LEGAL_URL}`,
  },
  UK: {
    appName: "Convo Now",
    companyName: "Convo",
    region: "UK",
    appLogoImageSrc: ConvoUS,
    addressBarImageSrc: AddressBarUK,
    permissionSettingImageSrc: PermissionSettingsUK,
    permissionOffImageSrc: PermissionOffUK,
    permissionOnImageSrc: PermissionOnUK,
    allowControlsImageSrc: AllowControlsUK,
    addressBarSafariImageSrc: AddressBarSafariUK,
    denyAllowImageSrc: DenyAllowUK,
    allowCamSettingsImageSrc: AllowCamSettingsUK,
    allowMicSettingsImageSrc: AllowMicSettingsUK,
    appLogoImageHeight: 30,
    ratingScreenText: "How was your experience using Convo today?",
    marketingUrl: `${process.env.REACT_APP_MARKETING_URL}`,
    hubspotFeedbackUrl: `${process.env.REACT_APP_HUBSPOT_FEEDBACK_URL}`,
    huMarketingUrl: `${process.env.REACT_APP_HU_MARKETING_URL}`,
    huHubspotFeedbackUrl: `${process.env.REACT_APP_HU_HUBSPOT_FEEDBACK_URL}`,
    legalURL: `${process.env.REACT_APP_LEGAL_URL}`,
  },
};

export default Config;
